import { Grid, Typography } from '@mui/material';
import { Box, Container } from '@mui/system';
import { useResponsive } from '@/components/hooks/useResponsive';
import { useSearchDirectoryData } from '@/context/searchDirectory/SearchDirectoryDataContext';
import { SearchResultsContainer } from '../SearchResultsContainer';
import { JobHowItWorks } from '../JobHowItWorks';

export const SearchResultsWithAsideSection = () => {
  const { seoSegmentationDetails } = useSearchDirectoryData();
  const { isSmallViewport, isLargeViewport } = useResponsive();

  return (
    <Box bgcolor="background.secondary" pt={8} pb={10} px={{ lg: 3 }}>
      <Container maxWidth="lg" disableGutters={isSmallViewport || isLargeViewport}>
        <Grid container>
          <Grid item xs={12}>
            <Typography
              variant={isSmallViewport ? 'h1' : 'display3'}
              component="h2"
              mb={0}
              mt={0}
              mx={isSmallViewport ? 3 : 0}
              dangerouslySetInnerHTML={{ __html: seoSegmentationDetails.searchResultsHeader }}
              sx={{ '& p:first-of-type': { margin: 0 } }}
            />
          </Grid>
          <SearchResultsContainer Aside={JobHowItWorks} />
        </Grid>
      </Container>
    </Box>
  );
};
